<template>
  <modal
    :title="`New Job for ${fullName(customer)}`"
    :saving="saving"
    @hide-modal="$emit('hide-modal')"
    @submit="handleSave"
  >
    <div class="d-flex font-bold flex-wrap">
      <div class="mr-1">Equipment at</div>
      <address-label :address="address" single></address-label>
    </div>
    <customer-equipment-datatable
      v-if="address"
      source="/reports/equipment_overview.json?values_only=true"
      :customer-id="address.owner_id"
      :address-id="address.id"
      :show-archived="false"
    ></customer-equipment-datatable>
    <div class="form-container">
      <schedule-job-module
        v-if="address"
        ref="form"
        :address="address"
      ></schedule-job-module>
    </div>
    <JobTagForm ref="jobTagForm" />
  </modal>
</template>

<script>
import { mapActions } from "vuex";

import AddressLabel from "@/components/AddressLabel.vue";
import Modal from "@/components/Modal.vue";
import CustomerEquipmentDatatable from "@/Equipment/CustomerEquipmentDatatable.vue";
import JobTagForm from "@/Job/JobTagForm.vue";
import useVuelidate from "@vuelidate/core";
import ScheduleJobModule from "./ScheduleJobModule.vue";

export default {
  components: {
    Modal,
    CustomerEquipmentDatatable,
    AddressLabel,
    ScheduleJobModule,
    JobTagForm
  },
  props: {
    address: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    },
    link: {
      type: String,
      default: ""
    }
  },
  emits: ["hide-modal"],
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  data() {
    return {
      saving: false
    };
  },
  methods: {
    ...mapActions(["createJob"]),
    async handleSave() {
      const isValid = await this.v$.$validate();
      const isFormValid = await this.$refs.form.validate();

      if (!isValid || !isFormValid) return;

      this.saving = true;
      const payload = this.$refs.form.getFormData();
      const tagIds = await this.$refs.jobTagForm.getFormData();
      payload.tags = tagIds;

      this.createJob({
        link: { href: this.link, method: "POST" },
        payload
      })
        .then((res) => {
          this.$router.push(this.jobShowPath(res.data.id));
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.saving = false;
          this.$emit("hide-modal");
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
